import { Layout, LayoutProps } from 'react-admin';
import { CustomMenu } from './CustomMenu';
import { CustomAppBar } from './CustomAppBar';

export const CustomLayout = (props: LayoutProps) => (
  <Layout
    {...props}
    menu={CustomMenu}
    appBar={CustomAppBar}
    sx={{
      '& .RaLayout-content': {
        padding: '24px',
        backgroundColor: '#161d31',
        minHeight: '100vh',
      },
      '& .RaLayout-appFrame': {
        backgroundColor: '#161d31',
      },
    }}
  />
);
